export const WGS_84_EPSG_CODE = 'EPSG:4326';
export const DEFAULT_MAP_CONFIG_ID = 'd-map-config';
